import ApiClient from './ApiClient';

class AiIgnoredNumbersAPI extends ApiClient {
  constructor() {
    super('ai_ignored_numbers', { accountScoped: true });
  }
}

export default new AiIgnoredNumbersAPI();
